import {initializeApp} from "firebase/app";
import {
  getFirestore,
  connectFirestoreEmulator,
  collection,
  doc,
  getDocs,
  getDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  startAfter,
  where,
  limit,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  uploadBytes,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import {
  getAuth,
  signOut,
  updateProfile,
  sendPasswordResetEmail ,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";

const app = initializeApp({
  apiKey: "AIzaSyBTSTiaw4egj0YCAan04gbek3J9Y66AdPw",
  authDomain: "flexposter.firebaseapp.com",
  projectId: "flexposter",
  storageBucket: "flexposter.appspot.com",
  messagingSenderId: "86513068837",
  appId: "1:86513068837:web:8580022c44088844c288cc",
  measurementId: "G-M4Q23TVESY"
});

const db = getFirestore(app);
const storage = getStorage(app);
// const functions = getFunctions(app);
const auth = getAuth();

export {
  db,
  storage,
  auth,
  updateProfile,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  collection,
  doc,
  where,
  signOut,
  getDocs,
  getDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  startAfter,
  limit,
  ref,
  uploadBytes,
  uploadBytesResumable,
  getDownloadURL,
};
